// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #FFD000;     /* your yellow */
  --text: #333;
  --bg-light: #f9f9f9;
  --card-bg: #fff;
}


* { box-sizing: border-box; margin: 0; padding: 0; }
body { background: var(--bg-light); font-family: 'Inter', sans-serif; color: var(--text); }

.landing-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

/* Hero */
.hero {
  background: var(--card-bg);
  padding: 60px 20px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.hero h1 { font-size: 2.5rem; margin-bottom: 16px; }
.hero .subtitle { font-size: 1.125rem; line-height: 1.6; }
.hero-ctas { margin-top: 24px; }
.hero-ctas .btn-primary,
.hero-ctas .btn-secondary { margin: 8px 8px; }

/* Buttons */
.btn-primary {
  background: var(--text);
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
}
.btn-secondary {
  background: transparent;
  color: var(--text);
  border: 2px solid var(--text);
  padding: 10px 22px;
  border-radius: 6px;
  cursor: pointer;
}

/* Signup Section */
.signup-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
}

.signup-section h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
  max-width: 600px;
}
.signup-card {
  background: var(--card-bg);
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
}

/* Benefits */
.benefits-section {
  background: var(--card-bg);
  padding: 40px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.benefits-section h2 {
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 24px;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.card {
  background: var(--bg-light);
  padding: 24px;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.card-icon { margin-bottom: 12px; color: var(--primary); }
.card h3 { font-size: 1.125rem; margin-bottom: 8px; }
.card p { font-size: 0.95rem; line-height: 1.5; }

/* Responsive */
@media (max-width: 768px) {
  .benefits-grid { grid-template-columns: 1fr; }
  .signup-section { justify-content: center; }
  .signup-section h2 { text-align: center; }
}`, "",{"version":3,"sources":["webpack://./src/styles/landing.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,MAAM,gBAAgB;EACxC,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;;AAGA,IAAI,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;AACnD,OAAO,2BAA2B,EAAE,gCAAgC,EAAE,kBAAkB,EAAE;;AAE1F;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,WAAW,iBAAiB,EAAE,mBAAmB,EAAE;AACnD,kBAAkB,mBAAmB,EAAE,gBAAgB,EAAE;AACzD,aAAa,gBAAgB,EAAE;AAC/B;4BAC4B,eAAe,EAAE;;AAE7C,YAAY;AACZ;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,aAAa,mBAAmB,EAAE,qBAAqB,EAAE;AACzD,WAAW,mBAAmB,EAAE,kBAAkB,EAAE;AACpD,UAAU,kBAAkB,EAAE,gBAAgB,EAAE;;AAEhD,eAAe;AACf;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,kBAAkB,uBAAuB,EAAE;EAC3C,qBAAqB,kBAAkB,EAAE;AAC3C","sourcesContent":[":root {\n  --primary: #FFD000;     /* your yellow */\n  --text: #333;\n  --bg-light: #f9f9f9;\n  --card-bg: #fff;\n}\n\n\n* { box-sizing: border-box; margin: 0; padding: 0; }\nbody { background: var(--bg-light); font-family: 'Inter', sans-serif; color: var(--text); }\n\n.landing-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n}\n\n/* Hero */\n.hero {\n  background: var(--card-bg);\n  padding: 60px 20px;\n  text-align: center;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n.hero h1 { font-size: 2.5rem; margin-bottom: 16px; }\n.hero .subtitle { font-size: 1.125rem; line-height: 1.6; }\n.hero-ctas { margin-top: 24px; }\n.hero-ctas .btn-primary,\n.hero-ctas .btn-secondary { margin: 8px 8px; }\n\n/* Buttons */\n.btn-primary {\n  background: var(--text);\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.btn-secondary {\n  background: transparent;\n  color: var(--text);\n  border: 2px solid var(--text);\n  padding: 10px 22px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* Signup Section */\n.signup-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 60px;\n}\n\n.signup-section h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 24px;\n  text-align: center;\n  max-width: 600px;\n}\n.signup-card {\n  background: var(--card-bg);\n  padding: 32px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  width: 100%;\n  max-width: 400px;\n}\n\n/* Benefits */\n.benefits-section {\n  background: var(--card-bg);\n  padding: 40px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n.benefits-section h2 {\n  text-align: center;\n  font-size: 1.75rem;\n  margin-bottom: 24px;\n}\n.benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n.card {\n  background: var(--bg-light);\n  padding: 24px;\n  border-radius: 6px;\n  text-align: center;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n}\n.card-icon { margin-bottom: 12px; color: var(--primary); }\n.card h3 { font-size: 1.125rem; margin-bottom: 8px; }\n.card p { font-size: 0.95rem; line-height: 1.5; }\n\n/* Responsive */\n@media (max-width: 768px) {\n  .benefits-grid { grid-template-columns: 1fr; }\n  .signup-section { justify-content: center; }\n  .signup-section h2 { text-align: center; }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
